import { render, staticRenderFns } from "./InformationPublishtable.vue?vue&type=template&id=5dec4bee&scoped=true&"
import script from "./InformationPublishtable.vue?vue&type=script&lang=js&"
export * from "./InformationPublishtable.vue?vue&type=script&lang=js&"
import style0 from "./InformationPublishtable.vue?vue&type=style&index=0&id=5dec4bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec4bee",
  null
  
)

export default component.exports